import { inSecondsToDate } from "./inSecondsToDate";
import { SigninResponseProxied } from "./signIn";

export type SignInInfo = {
  readonly expiresAt: Date;
  readonly refreshTokenExpiresAt: Date;
};

export function normalizeSigninResponse(
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  input: SigninResponseProxied
): SignInInfo {
  return {
    expiresAt: inSecondsToDate(input.expires_in ?? 0),
    refreshTokenExpiresAt: inSecondsToDate(input.refresh_token_expires_in ?? 0),
  };
}
